import { Link } from "react-router-dom";
import logoDefault from "@/assets/logo-permuta-digital.png";
import logoTransparent from "@/assets/logo-permuta-digital-transparent.png";
import logoWhite from "@/assets/logo-permuta-digital-white.png";
import { cn } from "@/lib/utils";

interface LogoProps {
  to?: string;
  className?: string;
  iconOnly?: boolean;
  /** Renderiza apenas o wordmark "Permuta Digital", sem o símbolo. */
  wordmarkOnly?: boolean;
  /**
   * default  → logo padrão (fundos claros)
   * light    → wordmark branco para fundos escuros/azul
   * onDark   → logo com símbolo legível em fundos escuros (transparente)
   */
  variant?: "default" | "light" | "onDark";
  size?: "sm" | "md" | "lg";
}

const sizes = {
  sm: { icon: "h-7 w-7", text: "text-lg" },
  md: { icon: "h-9 w-9", text: "text-xl" },
  lg: { icon: "h-12 w-12", text: "text-3xl" },
};

export const Logo = ({
  to = "/",
  className,
  iconOnly = false,
  wordmarkOnly = false,
  variant = "default",
  size = "md",
}: LogoProps) => {
  const s = sizes[size];
  const src =
    variant === "light" ? logoWhite : variant === "onDark" ? logoTransparent : logoDefault;

  const content = (
    <span className={cn("inline-flex items-center gap-2.5 font-display font-bold tracking-tight", className)}>
      {!wordmarkOnly && (
        <img
          src={src}
          alt="Permuta Digital"
          className={cn(s.icon, "object-contain")}
          loading="eager"
        />
      )}
      {!iconOnly && (
        <span
          className={cn(
            s.text,
            variant === "light" || variant === "onDark"
              ? "text-white"
              : "text-foreground"
          )}
        >
          Permuta{" "}
          <span
            className={
              variant === "light" || variant === "onDark"
                ? "text-[hsl(var(--brand-cyan-bright))]"
                : "text-gradient-brand"
            }
          >
            Digital
          </span>
        </span>
      )}
    </span>
  );

  if (!to) return content;
  return <Link to={to} className="inline-flex items-center">{content}</Link>;
};

export default Logo;
